<template>
  <div v-loading="loading" class="project-live-container simple-search-table-container">
    <el-tabs v-model="query.type" type="card" @tab-click="handelSearch">
      <el-tab-pane label="保量" name="money"/>
      <el-tab-pane label="其他" name="other"/>
    </el-tabs>
    <div class="head flex-align-center">
      <div style="display: flex;align-items: center;">
        <el-date-picker v-model="query.date_check"
                        type="month" value-format="yyyy-MM"
                        placeholder="搜索月份"
                        size="mini"
                        @change="handelSearch"
                        style="margin-right: 10px"
        />

        <select-artist :value.sync="query.artist_id" size="mini" @change="handelSearch"/>
        <el-button type="primary" size="mini" icon="el-icon-search" @click="handelSearch" style="margin:0 10px;">
          查询
        </el-button>

        <export-btn v-permission="'live_guarantee__export_stat'" size="mini" :can-export="true" btn-type="warning"
                    @export="handleExport('refExportBtn')" ref="refExportBtn" :lint-title="`导出`"/>
      </div>
      <div class="flex-align-center">
        <el-button icon="el-icon-refresh" type="text" circle :disabled="doLoading" :loading="doLoading"
                   @click="handleRunScript" style="padding:0;margin-right: 4px;"/>
        <span class="tip-time" v-if="tableData[0]&&tableData[0].last_time">
          最后更新时间：{{ tableData[0].last_time }}
        </span>
        <span v-else class="tip-time">暂无数据</span>
      </div>
    </div>
    <div style="height: calc(100% - 126px)">
      <el-table :data="tableData" height="calc(100% - 16px)" @sort-change="eventSortMethod">
        <el-table-column label="#" type="index"/>
        <el-table-column label="核算归属月份" prop="date_check" sortable width="120">
          <template v-slot="{row:{date_check}}">
            <b>{{ date_check|parseTime('{y}年{m}月') }}</b>
          </template>
        </el-table-column>
        <el-table-column label="红人名称" prop="nickname" show-overflow-tooltip width="130"/>
        <el-table-column label="平台" prop="platform" show-overflow-tooltip width="80"/>
        <el-table-column label="保量进度" prop="stage_schedule" header-align="right" align="right" sortable width="120">
          <template v-slot="{row:{stage_schedule}}">
            <div>{{ stage_schedule|numberFormat(1) }}%</div>
          </template>
        </el-table-column>
        <el-table-column label="可结算收入" prop="stage_amount" header-align="right" align="right" sortable width="120">
          <template v-slot="{row:{stage_amount}}">
            <b>￥{{ stage_amount|numberFormat(2) }}</b>
          </template>
        </el-table-column>
        <el-table-column label="累计保量进度" prop="accrue_schedule" header-align="right" align="right" sortable
                         width="120">
          <template v-slot="{row:{accrue_schedule}}">
            <div>{{ accrue_schedule|numberFormat(1) }}%</div>
          </template>
        </el-table-column>
        <el-table-column label="累计可结算收入" prop="accrue_amount" header-align="right" align="right" sortable
                         width="130">
          <template v-slot="{row:{accrue_amount}}">
            <b>￥{{ accrue_amount|numberFormat(2) }}</b>
          </template>
        </el-table-column>
        <el-table-column label="订单编号" algin="center" width="150">
          <template v-slot="{row}">
            <to-order-detail by-field="order_no" :order="{order_no:row.order_no}"/>
          </template>
        </el-table-column>
        <el-table-column label="乙方名称" prop="company_name" show-overflow-tooltip/>
        <el-table-column label="客户名称" prop="customer_name" show-overflow-tooltip width="130"/>
        <el-table-column label="销售" prop="sale" show-overflow-tooltip/>
        <el-table-column label="客户性质" prop="customer_nature" show-overflow-tooltip/>
        <el-table-column label="品牌" prop="brand" show-overflow-tooltip/>
        <el-table-column label="行业" prop="trade" show-overflow-tooltip/>
        <el-table-column label="产品/内容" prop="product" show-overflow-tooltip/>
        <el-table-column label="订单来源" prop="order_source" show-overflow-tooltip/>
        <el-table-column label="客单" prop="passenger_order_interval" show-overflow-tooltip/>
        <el-table-column label="品类" prop="product_category" show-overflow-tooltip/>
        <el-table-column label="合作形式" prop="form_of_cooperation" show-overflow-tooltip/>
        <el-table-column label="含税收入" prop="payment_account" show-overflow-tooltip/>
        <el-table-column label="备注" prop="remark" show-overflow-tooltip/>
        <el-table-column label="收款形式" prop="payment_method_alias" show-overflow-tooltip/>
        <el-table-column label="合同归档" prop="contract_filed_alias" show-overflow-tooltip/>
        <el-table-column label="合同编号" prop="contract_no" show-overflow-tooltip/>
        <el-table-column label="合同金额" prop="contract_amount" show-overflow-tooltip/>
        <el-table-column label="财务备注" prop="f_remark" show-overflow-tooltip/>
        <el-table-column label="是否保次" prop="is_quantity_times_alias" show-overflow-tooltip/>
        <el-table-column label="直播次数" prop="live_count" show-overflow-tooltip/>
        <el-table-column label="是否保量" prop="is_quantity_alias" show-overflow-tooltip/>
        <el-table-column label="保量金额" prop="gq_amount" show-overflow-tooltip/>
        <el-table-column label="是否完结" prop="is_done_order" show-overflow-tooltip>
          <template v-slot="{row:{is_done_order}}">
            {{ is_done_order == 0 ? '未完结' : '已完结' }}
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="created_at" show-overflow-tooltip/>
      </el-table>
      <el-pagination
          background
          :current-page="query.page"
          :page-sizes="[5,10,20,100, 200, 300, 400]"
          :page-size="query.page_size"
          layout="total, sizes, prev, pager, next"
          :total="query.total"
          style="margin-top: 10px;float: right;"
          @current-change="handleCurrentChange"
          @size-change="eventSizeChange"
      />
    </div>
  </div>
</template>

<script>
import ToOrderDetail from "@/views/adOrder/components/ToDetail.vue";

import moment from "moment";
import {copy} from "@/utils";
import {liveGuaranteeExportStat, liveGuaranteeListStat} from "../../../api/liveGuarantee";
import ExportBtn from "../../../components/export/ExportBtn.vue";
import {runReportOrderLiveScript} from "../../../api/order";
import SelectArtist from "../../../components/Selects/artist.vue";

export default {
  components: {SelectArtist, ExportBtn, ToOrderDetail},
  data() {
    return {
      copy,
      tableData: [],
      loading: false,
      doLoading: false,
      query: {
        page: 1,
        page_size: 20,
        total: 0,
        type: 'money',
        order_by: null,
        date_check: null,
        artist_id: null,
      },
    }
  },
  created() {
    this.query.date_check = moment().subtract(1, 'month').format('YYYY-MM');
    this.getTableData(true)
  },
  methods: {
    eventSizeChange: function (page_size) {
      this.query.page_size = page_size
      this.handelSearch()
    },
    eventSortMethod: function ({order, prop}) {
      let string = null;
      switch (order) {
        case 'descending':
          string = `${prop} desc`
          break;
        case 'ascending':
          string = `${prop} asc`
          break;
        default:
          break;
      }
      this.query.order_by = string
      this.getTableData(true)
    },
    handelSearch: function () {
      this.getTableData(true)
    },
    async handleRunScript() {
      let year = moment().format('YYYY')
      let month = moment().format('MM')
      if (this.query.date_check) {
        year = moment(this.query.date_check).format('YYYY')
        month = moment(this.query.date_check).format('MM')
      }

      //执行权限更新
      const string_s = `${year}年${month}月`;
      this.$confirm(
          `确定更新<b>${string_s}</b>数据吗？`,
          '更新直播汇总数据',
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(async () => {
            this.doLoading = true

            await runReportOrderLiveScript([{year, month}])
            this.msgSuccess('更新任务已发布，请稍后点击查询是否更新')

            setTimeout(() => {
              this.doLoading = false
            }, 500)
          })
    },
    handleExport: async function () {
      try {
        this.getSearch()
        const response = await liveGuaranteeExportStat(this.query)
        this.$refs.refExportBtn.exportSaveXlsx(response, '汇总导出')
      } catch (e) {
        this.$message.warning('导出异常，请联系管理员')
      }
    },
    handleCurrentChange: function (page) {
      this.query.page = page
      this.getTableData()
    },
    getSearch: function () {
      this.query.date_check = this.query.date_check ? moment(this.query.date_check).format('YYYY-MM') + '-01' : null
      return this.query
    },
    getTableData: async function (is_search = false) {
      // 查询重置 page
      is_search && (this.query.page = 1)
      this.getSearch()
      this.loading = true
      const response = await liveGuaranteeListStat(this.query)
      this.loading = false
      this.tableData = response.model.data || []
      this.query.total = response.model.total || 0
    },
    changeTableSort(_) {
      const {prop, order} = _
      let order_by = null
      if (order) {
        order_by = order === 'ascending' ? `\`${prop}\` asc` : `\`${prop}\` desc`
      }
      this.queryParams.order_by = order_by
      this.getTableData()
    }
  }
}
</script>

<style lang="scss">
.project-live-container {
  padding: 24px;

  .el-table .red-row {
    background: #ffeeee;
  }

  .el-table thead tr, .el-table thead th {
    background: white !important;
    color: #3c3c3c !important;
    font-weight: 600;
  }

  .flag-error {
    display: inline-block;
    width: auto;
    line-height: 17px;
    padding: 0 10px;
    border-radius: 9px;
    //border: 1px solid #ab0707;
    color: #FFFFFF;
    background-color: #ab0707;
    font-size: 12px;
    cursor: pointer;
  }

  .head {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;

    .el-select {
      //width: 250px;
      margin-right: 12px;
    }
  }

  .ape-table-container {
    height: calc(100% - 206px) !important;
  }

  .tip-time {
    color: #8a8e99;
    font-size: 12px;
    margin-right: 10px;
  }

  .tip-help {
    margin-top: 40px;
    margin-bottom: 10px;
    padding: 8px 24px;
    overflow-y: auto;
    background-color: #FFF9FBFC;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    line-height: 22px;
    color: #666;
    border-radius: 9px;
    position: relative;
    box-sizing: border-box;
    height: 110px;
  }

  .tag {
    border-radius: 3px;
    background-color: #ffeef3;
    color: #fe346e;
    font-size: 12px;
    padding: 0 8px;
    height: 20px;
    line-height: 20px;
  }

  .el-table .cell {
    height: auto !important;
  }

  .el-table th.el-table__cell > .cell {
    min-height: 34px !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .el-table .sort-caret.ascending {
    top: 7px !important;
  }

  .el-table .sort-caret.descending {
    bottom: 5px !important;
  }

  .over-hidden {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .live-sm:hover {
    .live-sm__mark {
      opacity: .7 !important;
    }
  }

  .live-sm {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    position: relative;
    cursor: pointer;

    &__mark {
      position: absolute;
      width: 100%;
      height: 100%;
      background: #111;
      opacity: 0;
      top: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border-radius: 4px;

      span {
        color: #FFFFFF;
        cursor: pointer;
      }
    }
  }
}
</style>
